import { OrderSide } from "../_app/types";

export class Order {
  public openPrice: number;
  public closePrice: number;
  public amount: number;
  public priceStep: number;
  public priceStepPercent: number;
  public orderSide: OrderSide;

  constructor(openPrice: number, closePrice: number, orderSide: OrderSide, amount: number) {
    this.openPrice = openPrice;
    this.closePrice = closePrice;
    this.amount = amount;
    this.orderSide = orderSide;
    this.priceStep = Math.abs(openPrice - closePrice);
    // this.priceStepPercent = Math.abs(openPrice - closePrice) / openPrice;
    this.priceStepPercent = Math.abs(closePrice / openPrice - 1);
  }
}
